var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.element.autoGenerate
        ? [
            _c(_vm.element.fieldType, {
              tag: "component",
              attrs: { element: _vm.element },
              model: {
                value: _vm.model,
                callback: function ($$v) {
                  _vm.model = $$v
                },
                expression: "model",
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }